document.addEventListener('DOMContentLoaded', function() {
    // Select all <h4> elements within the container with the class 'metafield-rich_text_field'
    var headers = document.querySelectorAll('.tab-pane .metafield-rich_text_field h4');

    // Loop through each <h4> element, add the classes to <h4>, and add 'plus-content' to following <p>
    headers.forEach(function(header) {
        header.classList.add('plus-accordion-header');
        var nextParagraph = header.nextElementSibling;
        if (nextParagraph && nextParagraph.tagName === 'P') {
            nextParagraph.classList.add('plus-accordion-content');
        }
    });
});

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.plus-accordion-header').forEach(header => {
        header.addEventListener('click', () => {
            const content = header.nextElementSibling;
            header.classList.toggle('active');
            if (content.style.display === 'block') {
                content.style.display = 'none';
            } else {
                content.style.display = 'block';
            }
        });
    });
});